import React from "react";
import HeroSection from "./Herosection";
import MainSection from "./MainSection";
import HowItWorks from "./HowItWorks.jsx";
import Footer from "./Footer.jsx";
import Navbar from "./Navbar.jsx";


const LandingPage=()=>{
return(
<div style={{contain: 'content'}}>
<Navbar/>

  <HeroSection />
  <MainSection />
  <HowItWorks />
  <Footer />
</div>
)};
export default LandingPage;